// extracted by mini-css-extract-plugin
export default {"skeletonLine":"SkeletonLine-skeletonLine-OcR","pulse":"SkeletonLine-pulse-ng4"};